<section class="editDocument__container">
  <header>
    <app-offcanvas-header paddingClass="paddingClass"
      header="{{ documentType ? 'Edit Category Type' : 'Add Category Type' }}"
    (closeClicked)="onCloseIconClick(false)"></app-offcanvas-header>
  </header>
  <form class="mt-3" [formGroup]="documentTypeFormGroup">
    <div class="offcanvas__content">
      <div class="offcanvas__orgDetails">
        <div class="offCanvas__orgName-inputField">
          <app-input-filed label="Name" placeholder="Enter name" [control]="$any(documentTypeFormGroup).controls['name']"
          [starIcon]="'*'" [value]="documentType?.name"></app-input-filed>
          @if (documentTypeFormGroup.get('name')?.errors?.['required'] && documentTypeFormGroup.get('name')?.touched) {
            <small class="text-danger"
              >
              Name is required.
            </small>
          }
          @if ((documentTypeFormGroup.get('name')?.dirty || documentTypeFormGroup.get('name')?.touched) && documentTypeFormGroup.get('name')?.errors?.['pattern']) {
            <small class="text-danger"
              >
              Please use only letters and numbers
            </small>
          }
          @if (errorMessage) {
            <small class="text-danger">{{ errorMessage }}
            </small>
          }
        </div>
      </div>
      @if (!documentType) {
        <div appAccessControl allowedModules="documentVault.ocrCategory">
          <div class="documentType__dropdown col-md-6">
            <div class="documentType__dropdownLabel">
              OCR Category
            </div>
            <select class="docType__dropdownOptions cursor-pointer" (change)="onSelectOcrCategory($event)">
              <option value="Select Document Category" disabled selected [ngValue]="''">Select Document Category</option>
              @for (item of ocrCategoryList; track item) {
                <option class="cursor-pointer" [ngValue]="item">
                  {{ item?.name }}
                </option>
              }
            </select>
          </div>
        </div>
      }

      @if (selectedOcrCategory && !documentType) {
        <div class="card mt-2" appAccessControl allowedModules="documentVault.ocrCategory">
          <div class="card-header ocrImageTitle">
            <div >
              Selected OCR Category
            </div>
            <div (click)="openMaxView(previewOcrDoc)">
              <fa-icon class="cursor" [icon]="faExpand" data-bs-toggle="tooltip" ></fa-icon>
            </div>
          </div>
          <div class=" ocrImageDiv ">
            <div class="imgDiv">
              <img alt="sample document" [src]="selectedOcrCategory?.originalDocument" />
            </div>
            <div class="imgDiv">
              <img alt="sample document" [src]="selectedOcrCategory?.parsedDocument" />
            </div>
          </div>
        </div>
      }
    </div>

    @if (tabvalue == 'recordtype') {
      <div class="offcanvas__content">
        <div class="offcanvas__orgDetails">
          <div class="offCanvas__orgName-inputField">
            <app-input-filed label="Record Type" placeholder="Enter recordtype" class="mt-3"
              [control]="$any(documentTypeFormGroup).controls['recordtype']" [starIcon]="'*'"
            [value]="documentType?.name"></app-input-filed>
            @if (documentTypeFormGroup.get('recordtype')?.invalid && documentTypeFormGroup.get('recordtype')?.touched) {
              <small class="text-danger"
                >
                Record Type is required.
              </small>
            }
            @if (errorMessage) {
              <small class="text-danger">{{ errorMessage }}>
              </small>
            }
          </div>
        </div>
      </div>
    }

    @if (tabvalue == 'contracttype') {
      <div class="offcanvas__content">
        <div class="offcanvas__orgDetails">
          <div class="offCanvas__orgName-inputField">
            <app-input-filed label="Contract Type" placeholder="Enter contracttype"
              [control]="$any(documentTypeFormGroup).controls['contracttype']" [starIcon]="'*'"
            [value]="documentType?.name"></app-input-filed>
            @if (documentTypeFormGroup.get('contracttype')?.invalid && documentTypeFormGroup.get('contracttype')?.touched) {
              <small class="text-danger"
                >
                Contract Type is required.
              </small>
            }
            @if (errorMessage) {
              <small class="text-danger">{{ errorMessage }}>
              </small>
            }
          </div>
        </div>
      </div>
    }

    @if (tabvalue === 'contracttype' || tabvalue === 'recordtype') {
      <div class="offcanvas__content">
        <div class="offcanvas__orgDetails">
          <div class="offCanvas__orgName-inputField">
            @if (tabvalue === 'contracttype' || tabvalue === 'recordtype') {
              <app-input-filed label="Description"
                placeholder="Enter description" [control]="$any(documentTypeFormGroup).controls['description']"
                [value]="documentType?.name">
              </app-input-filed>
            }
          </div>
        </div>
      </div>
    }


    @if (!showDropDown) {
      <div class="form-group">
        <span class="filterOffcanvas__inputlabel">Select MetaData</span>
        <div class="form-control form-select filterOffcanvas__inputlabel">
          <div (mouseleave)="showDropDown = false">
            <button class="drop-toggle btn flat" (click)="showDropdown()">
              @if (checkedMultiList.length<=0) {
                <span class="spancolor">
                Select MetaData</span>
              }
              @if (checkedMultiList.length>0) {
                <span class="spancolor">{{checkedMultiList.join(', ')}}</span>
              }
            </button>
            @if (showDropDown && listData.length>0) {
              <div class="drop-show">
                <div class="usersFilter__branchesField">
                  <div class="usersFilter__branchWrappar">
                    <img class="usersFilter__searchIcon" src="../../../../assets/Images/user-management/searchIcon.svg"
                      alt="search" />
                      <input (input)="handleFilter($event)" class="usersFilter__input" placeholder="Search" />
                    </div>
                  </div>
                  @for (item of listData; track item) {
                    <label for="checkBoxName">
                      <app-checkbox id="checkBoxName" checkboxStatus="{{item.checked}}"
                      (checked)="getMultiSelectedValue($event.event.target.checked, item)"></app-checkbox>
                      <span>{{item.label}}</span>
                    </label>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }

    </form>
    <div class="editDocument__footer">
      <div class="offCanvas__footer">
        <app-common-button buttonClass="smallbutton" buttonLabel="Cancel"
        (clickEvent)="onCloseIconClick(false)"></app-common-button>
        @if ((documentType ? hasEditAccess : true) && commonService.orgLock()) {
          <app-common-button
            buttonClass="smallFilledButton" [buttonLabel]="documentType ? 'Update' : 'Save'" (clickEvent)="onSubmit()"
          [loadingIcon]="verifyLoader" [disabled]="documentTypeFormGroup.invalid"></app-common-button>
        }
      </div>
    </div>
  </section>

  <div>
    <ng-template #previewOcrDoc let-modal style="z-index: 999">
      <div class="modal-header zindex-modal">
        <h4 class="modal-title" id="modal-basic-title">
          Preview OCR Document
        </h4>
        <div class="cursor" (click)="modal.close(false)" class="close"><img
        src="../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon"></div>
      </div>
      <div class="modal-body">
        <div class=" ocrImagemaxDiv ">
          <div class="maxImage">
            <img alt="sample document" [src]="selectedOcrCategory?.originalDocument" />
          </div>
          <fa-icon  [icon]="faArrowRight"  data-bs-toggle="tooltip" ></fa-icon>
          <div class="maxImage">
            <img alt="sample document" [src]="selectedOcrCategory?.parsedDocument" />
          </div>
        </div>
      </div>
    </ng-template>
  </div>